import { Component, ElementRef, ViewChild } from '@angular/core';
import { NasabahModel } from '../service/model/dashboard.model';
import { Router } from '@angular/router';
import { DraftService } from '../service/save-draft/save-draft.service';
import { DownloadDocumentService } from '../service/download-document/download-document.service';
import { concatMapTo } from 'rxjs';

@Component({
  selector: 'app-endorse-name-app-no-result',
  templateUrl: './endorse-name-app-no-result.component.html',
  styleUrls: ['./endorse-name-app-no-result.component.css']
})
export class EndorseNameAppNoResultComponent {

  todayDate : string = new Date().toISOString()
  dataDashboard: any;
  tandaTangan: any;
  login: any;
  endorseResponse: any;

  @ViewChild('btnAcceptance')
  btnAcceptance!: ElementRef;

  @ViewChild('btnAcceptance2')
  btnAcceptance2!: ElementRef;

  constructor(private route: Router,
              private draftService: DraftService,
              private documentService: DownloadDocumentService) {
    let background = document.getElementById("background");
    if (background != null) {
      background.className = "allianz-background-faded"
    }

    let jsonLogin = sessionStorage.getItem('login')

    if (jsonLogin) {
      this.login = JSON.parse(jsonLogin);
    }

    let jsonDataDashboard = localStorage.getItem("selected-item")
    if (jsonDataDashboard) {
      this.dataDashboard = JSON.parse(jsonDataDashboard);
    }

    let jsonEndorse = localStorage.getItem('endorsement-non-financial-response')
    if(jsonEndorse) {
      this.endorseResponse = JSON.parse(jsonEndorse);
    }
  }

  backToMenu() {
    localStorage.setItem('from-endorse-name-app-no', 'false')
    this.route.navigate(['eform/menu'])
  }

  backToDashboard() {
    localStorage.setItem('from-endorse-name-app-no', 'false')
    this.route.navigate(['eform/dashboard'])
  }

  downloadAkseptasi() {
    this.documentService.downloadDocument({
      referenceNo: this.dataDashboard.referenceNo,
      docType: "ACCEPTANCE"
    }).subscribe(res => {
      this.btnAcceptance.nativeElement.download = 'Surat Akseptasi ' + this.dataDashboard.referenceNo + '.pdf'
      this.btnAcceptance.nativeElement.href = 'data:application/octet-stream;base64,' + res.document;
      this.btnAcceptance.nativeElement.click()
    })
  }

  downloadTagihan() {
    this.documentService.downloadDocument({
      referenceNo: this.dataDashboard.referenceNo,
      docType: "INVOICE"
    }).subscribe(res => {
      this.btnAcceptance2.nativeElement.download = 'Surat Tagihan ' + this.dataDashboard.referenceNo + '.pdf'
      this.btnAcceptance2.nativeElement.href = 'data:application/octet-stream;base64,' + res.document;
      this.btnAcceptance2.nativeElement.click()
    })
  }
}
